import EpisodeLayout from "./EpisodeLayout";
import { getTranslations } from "../utils/translations";

function BroadcastPlayerView({ playlist, currentPlaylistItem, videoRef, playlistContainerRef, isAdPlaying, textColor, isVPVBranded }) {
    const t = getTranslations();
    console.log('🎨 BroadcastPlayerView isAdPlaying:', isAdPlaying);
    return (
        <div id="broadcast-player" className={`video-player-container${isAdPlaying ? ' ad-playing' : ''} ${isVPVBranded ? 'vpv-branded' : ''}`}> 
          <div id="left-content" className="clearfix video-player-wrapper" 
            style={{display: 'flex', flexDirection: 'column', height: '100%', gap: '0px'}}>
            <div data-vjs-player className='broadcast-player-wrapper'>
              <video ref={videoRef} poster={currentPlaylistItem?.poster} className="video-js vjs-big-play-centered" />
            </div>
            <EpisodeLayout episode={currentPlaylistItem} textColor={textColor} />
          </div>
          <div id="right-content">
            <div className="mobile-only">
              {t.moreFrom}{currentPlaylistItem.seriesName}
            </div>
            <div className="vjs-playlist" ref={playlistContainerRef} />
          </div>
        </div>
    );
}   
export default BroadcastPlayerView;